import { render, staticRenderFns } from "./MetroConnectMplsWizard.vue?vue&type=template&id=486e8b71&"
import script from "./MetroConnectMplsWizard.vue?vue&type=script&lang=js&"
export * from "./MetroConnectMplsWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports